import styled from "vue-styled-components";

export const Content = styled.div`
    display: grid;
    grid-template-areas: "A B" "C C";
    grid-template-columns: calc(100% - 90px) 90px;
    grid-row-gap: 1rem;

    padding: 1.6rem 1rem;
    border-bottom: 1px solid ${props => props.theme?.cart?.internal_border_color ?? '#e6ebee'};

    .product-principal-cart {
        grid-area: A;
        align-self: center;

        h2 {
            font-size: ${props => props.theme?.cart?.product_name?.font_size ?? '1.5rem'};
            line-height: 1.2;
            margin-bottom: 0.4rem;
            color: ${props => props.theme?.cart?.product_name?.color ?? '#2b2b2d'};
            text-decoration: none;
            transition: color 0.2s;
            cursor: pointer;
            font-weight: ${props => props.theme?.cart?.product_name?.font_weight ?? '400'};
            text-transform: ${props => props.theme?.cart?.product_name?.text_transform ?? 'initial'};

            &:hover {
                color: ${props => props.theme?.cart?.product_name?.color_hover ?? '#2b2b2d'};
            }
        }

        .dropdown__flavor + .dropdown__flavor::before {
            content: ' / ';
        }

        .product-flavors-cart,
        .dropdown__flavor {
            display: inline;
        }
    }

    span {
        display: block;
        font-size: 1.3rem;
        font-weight: 400;
        color: ${props => props.theme?.cart?.product_name?.color ?? '#2b2b2d'};
    }

    figure {
        grid-area: B;
        position: relative;
        max-width: 80px;
        align-self: center;
        margin: 0;
        margin-left: auto;
        border: 1px solid #ededed;
        box-shadow: none !important;
        width: 100%;
        display: flex;
        justify-content: center;

        .image-product-cart {
            img {
                max-height: 80px;
                object-fit: contain;
            }
        }
        .remove-product-cart {
            display: flex;
            position: absolute;
            top: -1rem;
            right: -1rem;
            align-items: center;
            justify-content: center;
            width: 2rem;
            height: 2rem;
            border-radius: 50%;
            background-color: #fff;
            color: #474747;
            font-size: 1.1rem;
            line-height: 1;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
            transition: 0.2s;

            &:hover {
                box-shadow: 0 3px 7px rgba(0, 0, 0, 0.3);
            }
        }
    }

    .product-children-cart {
        grid-area: C;

        .product-child-cart {
            display: flex;
            justify-content: space-between;
        }
    }
`;
